module.exports = __webpack_public_path__ + "static/media/background.f7b2e00a.jpg";